import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ContactSection from "./ContactSection";
import BackToTop from "./BackToTop";
import { Outlet } from "react-router-dom"; // <-- Import Outlet

export default function MasterLayout() {
  return (
    <>
      <Navbar />
      <Outlet />           {/* This is now where page content goes */}
      <ContactSection />
      <Footer />
      <BackToTop />
    </>
  );
}
